import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { commonResourceStyle } from '../../css/style';
import { Breadcrumbs } from '@material-ui/lab';
import SvgIcon from '@material-ui/core/SvgIcon';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { titleCase } from '../../utils/Functions';

const styles = commonResourceStyle();

class CraverBreadCrumb extends Component {
  static propTypes = {
    resource: PropTypes.string,
    resourceId: PropTypes.string,
    resourceName: PropTypes.string,
    subResource: PropTypes.string,
  }

  /**
   * Handler for rendering either a link to a CRUD page or to a Resource page
   */
  renderResourceLink = (resource, resourceId, subResource) => (
    subResource ? this.renderItemLink(resource, resourceId, subResource) : this.renderDisplayLink(resource)
  )

  /**
   * Renders a link to a resource page (Used when in subResource)
   */
  renderDisplayLink = (resource) => {
    const resourceName = (resource === 'products' ? 'menu' : resource);
    const resourceDisplayName = (resource === 'customizations' ? 'modifier groups' : resourceName);
    return (
      <Link to={`/${resourceName}/`} style={styles.breadcrumbItem}>
        {resourceDisplayName.charAt(0).toUpperCase() + resourceDisplayName.slice(1)}
      </Link>
    );
  }

  /**
   * Render when you are in a subResource (e.g. a ProductItem)
   */
   renderItemLink = (resource, resourceId, subResource) => {
     if (!(resource && resourceId && subResource)) return;
     let path = `/${resource}` + `/${resourceId}` + `/${subResource}`;
     if (resource === 'users') path = `/${resource}`;
     return (
      <a href={path} style={styles.breadcrumbItem}>
        {resource.charAt(0).toUpperCase() + resource.slice(1)}
      </a>
     );
   }

  /**
   * renders a label for resource
   */
  renderResourceLabel = (resource) => {
    const resourceName = (resource === 'customizations' ? 'modifier groups' : resource);
    return (
      <Typography style={styles.breadcrumbItemActive}>
        {resourceName.charAt(0).toUpperCase() + resourceName.slice(1)}
      </Typography>
    );
  }

  /**
   * Renders if the viewed page is a subresource
   */
  renderSubResourceLabel = (resourceName) => {
    const finalResourceName = this.getCorrectedResourceName(resourceName);
    if (finalResourceName) {
      return (
        <Typography style={styles.breadcrumbItemActive}>
          {titleCase(finalResourceName)}
        </Typography>
      );
    }
  }

  getCorrectedResourceName = (resourceName) => {
    if (resourceName === 'zones') return 'Delivery Zone';
    return resourceName;
  }

  renderSubResourceLink = (resource, resourceId, subResource) => (
    <Link to={`/${resource}/${resourceId}/${subResource}`} style={styles.breadcrumbItem}>
      {titleCase(this.getCorrectedResourceName(subResource))}
    </Link>
  )

  /**
   * Either renders a label for current page or a link for a parent page
   */
  handlerenderResource = (resource, resourceId, subResource) => (
    resourceId ? this.renderResourceLink(resource, resourceId, subResource) : this.renderResourceLabel(resource)
  )

  handlerenderSubResource = (resource, resourceId, subResource, subResourceId) => {
    if (subResource) {
      return (subResourceId ? this.renderSubResourceLink(resource, resourceId, subResource) : this.renderSubResourceLabel(subResource));
    }
  }

  render() {
    const {
      resource, resourceId, resourceName, subResource, subResourceId,
    } = this.props;

    const resourceTitle = resource === 'products' ? 'items' : resource;
    const subResourceTitle = subResource === 'items' ? 'variations' : subResource;

    return (
      <Breadcrumbs
        style={styles.breadcrumb}
        separator={(<SvgIcon><path fill="#000000" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></SvgIcon>)}
      >
        {this.handlerenderResource(resourceTitle, resourceId, subResourceTitle)}
        {this.handlerenderSubResource(resourceTitle, resourceId, subResourceTitle, subResourceId)}
        {this.renderSubResourceLabel(resourceName)}
      </Breadcrumbs>
    );
  }
}

CraverBreadCrumb.propTypes = {
  resource: PropTypes.string.isRequired,
  resourceId: PropTypes.string,
  resourceName: PropTypes.string,
  subResource: PropTypes.string,
  subResourceId: PropTypes.string,
};

export default withRouter(CraverBreadCrumb);
